import document from "./document";

// eslint-disable-next-line
const location = {
  pathname: () => document.location.pathname,
  origin: () => document.location.origin,
  hostname: () => document.location.hostname,
  redirect: (url) => document.location.replace(url),
  redirectWithReturnUrl: (url) => {
    window.location.replace( url + (document.location.pathname ? `&ReturnUrl=${document.location.pathname}` : ''))
  }
}
// eslint-disable-next-line
export default location;
